import React from 'react';
import {
	HeaderSocialDiscord,
	HeaderSocialTelegram,
	HeaderSocialTwitter,
	HeaderSocialYoutube
} from "../../images/HeaderSocialIcons";

interface HeaderCompanyItemProps {
	title: string;
	link: string;
	type: "Twitter" | "Discord" | "YouTube" | "Telegram";
	mode: 'dark' | 'light';
}

const HeaderSocialItem = (props: HeaderCompanyItemProps) => {

	return (
		<div
			className={`header_social_link ${props.mode}`}
			onClick={() => window.open(props.link)}
		>
			{
				props.type === "Twitter" ? (
					<HeaderSocialTwitter />
				) : props.type === "Discord" ? (
					<HeaderSocialDiscord />
				) : props.type === "YouTube" ? (
					<HeaderSocialYoutube />
				) : (
					<HeaderSocialTelegram />
				)
			}
			<span>{props.title}</span>
		</div>
	);
};

export default HeaderSocialItem;